import { Toaster as SonnerToaster, toast } from "sonner";
import type { ComponentProps } from "react";

/**
 * Application-wide toast host. Mounted once in the app shell; anything can then call {@link toast}.
 *
 * <p>Louder and slower than sonner's default since US-37.4 (UX-10). The audit read "Wsad RB-2026-0085
 * w wypale" as grey on white, gone in three seconds — which is fine at a desk and useless at the
 * tablet by the roaster, where the reader is a metre away, wearing gloves and not looking at the
 * moment the message arrives. So: the card's own foreground colour rather than the muted one, a
 * success mark in the roastery's green, and six seconds instead of four.
 *
 * <p>Six for everything rather than six for the warehouse alone: a toast is the only trace a finished
 * action leaves, and a screen where some messages outlast others teaches nobody anything.
 */
export function Toaster(props: ComponentProps<typeof SonnerToaster>) {
  return (
    <SonnerToaster
      position="bottom-right"
      duration={6000}
      toastOptions={{
        classNames: {
          toast:
            "rounded-md border border-border bg-card text-card-foreground shadow-lg text-sm font-medium",
          // Full colour, not a faded one: at 80 % over white this measures 4.02:1, which is under
          // AA. The description is told apart from the title by weight instead (US-37.4, UX-10).
          description: "text-card-foreground font-normal",
          success: "border-success/50",
          error: "border-destructive/50",
          warning: "border-warning/60",
          icon: "shrink-0",
        },
      }}
      {...props}
    />
  );
}

export { toast };
